import ErrorBoundary from './ErrorBoundary';

const applyErrorBoundary = Component => {
  const ProtectedRoute = props => {
    return (
      <ErrorBoundary>
        <Component {...props} />
      </ErrorBoundary>
    );
  };
  return ProtectedRoute;
};

export { applyErrorBoundary };
